'use client'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

export function initBugsnagClient() {
  if (Bugsnag.isStarted()) return
  const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY
  if (!apiKey) return

  const appVersion = process.env.NEXT_PUBLIC_APP_VERSION || undefined

  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    appVersion,
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ['production', 'staging'],
  })
}

export function getBugsnagErrorBoundary() {
  const plugin = Bugsnag.getPlugin('react')
  return plugin ? plugin.createErrorBoundary(React) : null
}

export function setBugsnagUser(user: { id: string; email?: string | null }) {
  if (!Bugsnag.isStarted()) return
  Bugsnag.setUser(user.id, user.email ?? undefined)
}

export function clearBugsnagUser() {
  if (!Bugsnag.isStarted()) return
  Bugsnag.setUser()
}
